import React from 'react'

import Divider from 'components/common/Divider'
import Text from 'components/common/Text'

import Blocks from './Blocks'
import { Container, Row, Close, Overlay } from './styles'

import ProgressWithCopy from '../ProgressWithCopy'
import QuitestStudents from '../QuitestStudents'

const MIN_STUDENTS_REQD = 3

const MaxStats = ({
    userId,
    isTeacher,
    percentage,
    color,
    onClick,
    ttmData,
}) => {
    const progressProps = {
        color,
        percentage,
        isTeacher,
        rowReverse: true,
    }

    const quietestStudentProps = {
        userId,
        students: ttmData?.students,
        rowReverse: true,
    }

    const studentsCount = ttmData?.students?.length

    return (
        <Overlay>
            <Container>
                <Text level="5">Oh. Babble Meter</Text>
                <Close
                    src="assets/revamp/cross.svg"
                    alt="close"
                    onClick={onClick}
                />
                <Row>
                    <ProgressWithCopy {...progressProps} />
                    <QuitestStudents {...quietestStudentProps} />
                </Row>
                {studentsCount > MIN_STUDENTS_REQD ? (
                    <>
                        <Divider color="#FFF" />
                        <Row flexStart>
                            <Text level="3">{studentsCount} students</Text>
                        </Row>
                        <Row flexStart>
                            <Blocks
                                localUserId={userId}
                                data={[ttmData?.teacher, ...ttmData?.students]}
                            />
                        </Row>
                    </>
                ) : null}
            </Container>
        </Overlay>
    )
}

export default MaxStats
